import { store } from '@/state/store';
import { DTO__word } from '@shared/dto/+word/word_translated/DTO__word';
import { DTO__words_vocabulary } from '@shared/dto/+word/word_translated/DTO__words_vocabulary';
import { DTO__token } from '@shared/dto/generation/settings/token/DTO__token';
import { ENUM__language_type } from '@shared/enums/ENUM__language_type';

//when client receives entities from server, we need to establish words for tokens 'cause tokens.word is undefined by design
export const establish_word_object_for_tokens = (tokens: DTO__token[]) => {
  let { user_settings } = store.getState().slice_user;

  //we rely on i18n because user could be unauthorized
  let vocabulary = store.getState().slice_words.words_vocabularies.get(user_settings.regional_language) || DTO__words_vocabulary.CREATE_STUB();

  let out = [];

  for (let token of tokens) {
    let word = vocabulary.words_map.get(token.word_english);

    if (word) {
      word = word.clone();
    } else {
      word = new DTO__word();
      word.word_english = token.word_english;
      word.word_translated = token.word_english;
      word.language = ENUM__language_type.ENGLISH;
    }

    let token_with_word = token.clone({ word });

    out.push(token_with_word);
  }

  return out;
};
